import { render, staticRenderFns } from "./DishPhotoUpload.vue?vue&type=template&id=0499d4a4&scoped=true&"
import script from "./DishPhotoUpload.vue?vue&type=script&lang=js&"
export * from "./DishPhotoUpload.vue?vue&type=script&lang=js&"
import style0 from "./DishPhotoUpload.vue?vue&type=style&index=0&id=0499d4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499d4a4",
  null
  
)

export default component.exports